import { PlanningIcon, type PlanningIconName } from './PlanningIcons';
import { WeddingIcon, type WeddingIconName } from './WeddingIcons';

const planning: Record<string, PlanningIconName> = {
  'Planning Tools': 'checklist', 'My Wedding': 'wedding', Checklist: 'checklist',
  'Budget Planner': 'budget', 'Wedding Budget': 'budget', 'Guest List': 'guests', Guests: 'guests',
  'Wedding Website': 'website', 'Wedding Websites': 'website', 'Wedding Cost Estimator': 'estimate',
  Inspiration: 'moodboard', Advice: 'guides', 'General Advice': 'guides', 'Expert Advice': 'guides',
  'Real Wedding': 'wedding', Ceremony: 'wedding', 'Post-Wedding': 'notes',
};
const categories: Record<string, WeddingIconName> = {
  'Wedding Venues': 'venue', Affordable: 'affordable', Barn: 'barn', Castle: 'castle',
  'Country House': 'house', Hotel: 'hotel', Intimate: 'intimate', Luxury: 'luxury', Outdoor: 'outdoor',
  'Pub / Restaurant': 'pub', Photographers: 'camera', Florists: 'flower', Music: 'music',
  Videographers: 'video', Catering: 'catering', Entertainment: 'party', Cakes: 'cake',
  'Wedding Dresses': 'dress', Menswear: 'suit', 'Wedding Rings': 'rings', Planners: 'planner',
  Celebrants: 'celebrant', 'Beauty, Hair & Makeup': 'beauty', Stationery: 'stationery', Transport: 'car',
  'Decoration & Hire': 'decor', 'Marquee Hire': 'marquee', 'Wedding Suppliers': 'flower',
  'Find Suppliers': 'search', 'For Businesses': 'portal', 'Business login': 'portal',
};
const colours = ['text-primary', 'text-[hsl(326_36%_45%)]', 'text-[hsl(186_30%_32%)]', 'text-[hsl(25_52%_39%)]'];
export function NavigationIcon({ name, index = 0 }: { name: string; index?: number }) {
  if (planning[name]) return <PlanningIcon name={planning[name]} className="h-7 w-7" />;
  return <WeddingIcon name={categories[name] ?? 'portal'} className={`h-6 w-6 ${colours[index % colours.length]}`} />;
}
